import React, { useState, useEffect, FC } from "react";
import { LoadingComponent } from "../../components/common/Loading";
import { PageTitle } from "../../../_jutemplate/layout/core";

export const DashboardPage: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const bufferTime = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearInterval(bufferTime);
  });
  
  //breadcrumbs={[{ title: "string", path: "string", isActive: true , isSeparator: false }]}

  return (
    <div>
      <PageTitle>DashBoard</PageTitle>
      {loading ? (
        <LoadingComponent />
      ) : (
        <div className="row mt-20 justify-content-center">
          <h2 className="text-center" style={{color:'#91425f'}}>Welcome To VIRGINIA TECH DashBoard</h2>
        </div>
      )}
    </div>
  );
};
